import React from 'react';
import { useParams } from 'react-router-dom';
import UserService from '../services/UserService';
import SEO from './SEO';
import DealListPage from './DealListPage';

function Store() {
  let { store } = useParams();

  return (
    <>
      <SEO title={`${store} Deals`} description={`The best ${store} deals and coupons, hand-picked daily by DinoDealz.`} />
      <DealListPage
        title={`${store} Deals`}
        crumb={store}
        loadDeals={() => UserService.getStoreDeals(store)}
        reloadKey={store}
        emptyText={`No ${store} deals right now. Check back soon!`}
      />
    </>
  );
}

export default Store;
